<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6">
                            <div class="d-flex align-items-center">
                            <div class="edit">
                                <button (click)="backToMyProjectV2()">
                                    <span><i class="ri-arrow-left-line"></i></span>
                                </button>
                            </div>
                            <h3 class="px-3">My Project</h3>
                        </div>
                        </div>
                        <div class="col-sm-6 d-flex justify-content-end">
                            <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                                <button type="button" title="Edit" (click)="updateSubProject()" data-bs-toggle="modal">
                                    <span><i class="ri-pencil-line"></i></span>
                                </button>
                            </div>
                            <div class="add-btn">
                                <button type="button" title="Create" (click)="openSubProject()"  class="btn btn-icon">
                                  <i class="ri-add-line"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6 d-flex" >
                            <h3><a (click)="openProjectTab('myparameter-v2')">Details</a></h3>
                            <h3><a class="active">Sub-Project</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('task-v2')">Tasks</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('resource-v2')">Resources</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('partlist')">Part List</a></h3>
                        </div>
                    </div>
                    <ag-grid-angular
                        style="height: calc(100vh - 120px) !important;" 
                        class="ag-theme-material"
                        (gridReady)="onGridReady($event)" 
                        [rowData]="rowData" 
                        [columnDefs]="columnDefs"
                        pagination="true" 
                        [defaultColDef]="defaultColDef"
                        [suppressRowClickSelection]="true"
                        [rowSelection]="rowSelection"
                        (selectionChanged)="onSelectionChanged($event)"
                        paginationPageSize=10>
                    </ag-grid-angular>
                </div>
            </section>
        </section>
    </article>
</main>
